import React from "react";
import useStyles from "./styles";
import { Pie, PolarArea } from "react-chartjs-2";
import {
  Card,
  CardHeader,
  Avatar,
  CardContent,
  CircularProgress
} from "@material-ui/core";
import { PieChart as PieCon } from "@material-ui/icons";
import { PieChartProps } from "../PieChart/types";

const PieChart = ({
  title,
  polar,
  chartData,
  options,
  isLoading
}: PieChartProps) => {
  const classes = useStyles();

  return (
    <Card>
      {title ? (
        <CardHeader
          title={title}
          className={classes.header}
          avatar={
            <Avatar aria-label={title} className={classes.avatar}>
              <PieCon />
            </Avatar>
          }
        />
      ) : (
        <CardHeader />
      )}
      <CardContent className={classes.container}>
        {!polar ? (
          <Pie
            type={Pie}
            data={() => {
              return {
                labels: chartData.labels,
                datasets: chartData.datasets.map(d => ({
                  label: d.label,
                  backgroundColor: d.rgbColor.map(
                    d => `rgba(${d.r},${d.g},${d.b}, 0.6)`
                  ),

                  data: d.data
                }))
              };
            }}
            options={options ? options : ""}
          />
        ) : (
          <PolarArea
            type={PolarArea}
            data={() => {
              return {
                labels: chartData.labels,
                datasets: chartData.datasets.map(d => ({
                  label: d.label,
                  backgroundColor: d.rgbColor.map(
                    d => `rgba(${d.r},${d.g},${d.b}, 0.6)`
                  ),

                  data: d.data
                }))
              };
            }}
            options={options ? options : ""}
          />
        )}
        {!isLoading ? (
          <></>
        ) : (
          <div className={classes.spinnerContainer}>
            <CircularProgress />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default PieChart;
